import * as actionTypes from "../actionTypes";
import { capitalize } from "utils/helpers";
export const defaultDropdownValue = "All";
export const initialDropdownData = { name: "All", id: defaultDropdownValue };

const initialState = {
  inspectors: [initialDropdownData],
  roomAreas: [initialDropdownData],
  serviceItems: [initialDropdownData],
  masterData: [initialDropdownData],
  appliedFiltersData: {
    results: [],
    global_score: {
      percentage: "NA",
      score: "NA",
      total_inspections: "0",
    },
  },
  infoFilters: {
    fromDate: new Date().setDate(new Date().getDate() - 30),
    toDate: new Date(),
    level: defaultDropdownValue,
    division: defaultDropdownValue,
    client: defaultDropdownValue,
    serviceLocation: defaultDropdownValue,
    subLocation: defaultDropdownValue,
    section: defaultDropdownValue,
    inspector: defaultDropdownValue,
    roomArea: defaultDropdownValue,
    serviceItem: defaultDropdownValue,
  },
  userDetail: {},
};
const inspectionPerfomanceReducer = (state, { type, payload }) => {
  if (state === undefined) {
    state = initialState;
  }
  let object;
  switch (type) {
    case actionTypes.ResetInspectionInfoFiltersLists:
      object = { ...state, ...payload };
      break;
    case actionTypes.InspectionInfoFilters:
      object = { ...state, infoFilters: payload };
      break;
    case actionTypes.ResetInspectionInfoFilters:
      object = {
        ...state,
        infoFilters: initialState.infoFilters,
      };
      break;
    case actionTypes.InspectionInspectorSuccess:
      object = {
        ...state,
        inspectors: [initialDropdownData, ...payload],
      };
      break;

    case actionTypes.InspectionMasterDataSuccess:
      const rows = payload || [];

      const uniqById = (arr) => {
        const map = new Map();
        arr.forEach((item) => {
          if (item?.id && !map.has(item.id)) {
            map.set(item.id, item);
          }
        });
        return Array.from(map.values());
      };

      const prependDefault = (arr) => [{ id: "All", name: "All" }, ...arr];
      const inspectors = uniqById(
        rows.map((r) => r.inspector_full).filter(Boolean)
      ).map(({ id, name }) => ({ id, name }));
      const serviceItems = uniqById(rows.flatMap((r) => r.services || [])).map(
        ({ id, name }) => ({ id, name })
      );
      const roomAreas = uniqById(
        rows.flatMap((r) => r.area_templates || [])
      ).map((data) => ({
        id: data.name,
        name: capitalize(data.name),
      }));

      object = {
        ...state,
        inspectors: prependDefault(inspectors),
        roomAreas: prependDefault(roomAreas),
        serviceItems: prependDefault(serviceItems),
        masterData: [...payload],
      };

      break;
    case actionTypes.ApplyInspectionInfoFiltersSuccess:
      object = {
        ...state,
        appliedFiltersData: { ...state.appliedFiltersData, ...payload },
      };
      break;
    case actionTypes.InspectionUserDetailSuccess:
      object = {
        ...state,
        userDetail: { ...state.userDetail, ...payload },
      };
      break;
    default:
      object = state;
  }
  return object;
};
export default inspectionPerfomanceReducer;
